import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import store from "./redux/store";
import {Provider} from "react-redux";
import {SnackbarProvider} from "notistack";

ReactDOM.render(
    <Provider store={store}>
        <SnackbarProvider maxSnack={2}>
            <App/>
        </SnackbarProvider>
    </Provider>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
